module.exports = __webpack_public_path__ + "img/paibian-jin.c02686d9.png";